import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Alert } from './ui/alert';

interface RechazoModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (razon: string) => void;
  loading?: boolean;
}

export function RechazoModal({ open, onClose, onSubmit, loading = false }: RechazoModalProps) {
  const [razon, setRazon] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleGuardar = () => {
    if (!razon.trim()) {
      setError('La razón de rechazo es obligatoria.');
      return;
    }
    setError(null);
    onSubmit(razon.trim());
    setRazon('');
  };

  const handleClose = () => {
    setRazon('');
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Razón de rechazo</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <label className="block font-medium mb-1">Por favor, ingresa la razón del rechazo:</label>
          <Textarea
            value={razon}
            onChange={e => setRazon(e.target.value)}
            placeholder="Describe la razón de rechazo..."
            rows={4}
            disabled={loading}
            className="w-full"
          />
          {error && <Alert variant="destructive">{error}</Alert>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={loading}>Cancelar</Button>
          <Button variant="destructive" onClick={handleGuardar} disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
